import styled from 'styled-components';

interface ThemeProps {
  theme: 'light' | 'dark';
}

export const FooterContainer = styled.footer<ThemeProps>`
  padding: 2rem 5%;
  background-color: var(--background);
  margin-top: auto;
  border-top: 1px solid
    ${(props) =>
      props.theme === 'light' ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'};
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: 2rem;

  a {
    color: var(--subtle-text);
    font-size: 0.9rem;
    transition: color 0.2s;

    &:hover {
      color: var(--primary);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  a {
    color: var(--subtle-text);
    transition: color 0.2s;

    &:hover {
      color: var(--primary);
    }
  }
`;

export const Copyright = styled.p`
  color: var(--subtle-text);
  font-size: 0.8rem;
  text-align: center;
`;
